// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const TERAGEN_ETEX_FIELD_ALIASES = {
  hospitalName: ['처 방 처 명'],
  drugName: ['제 품 명'],
  unitPrice: ['약 가'],
  quantity: ['수 량'],
  prescriptionAmount: ['처방금액'],
  feeRate: ['수수료(%)'],
  settlementAmount: ['정산금액'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '처 방 월',
  '처 방 처 명',
  '제 품 명',
  '약 가',
  '수 량',
  '처방금액',
  '수수료(%)',
  '정산금액',
  '비고',
];

function isTeragenEtexProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const teragenEtexTemplate = {
  id: 'teragen-etex',
  name: '테라젠이택스 템플릿',
  match(context) {
    return context.headerProfiles.some(isTeragenEtexProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isTeragenEtexProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(TERAGEN_ETEX_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '테라젠이택스';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: row[columnMap.hospitalName],
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default teragenEtexTemplate;
